export * from './PasteAsTextPlugin'
